import { clamp } from "./mathUtils.js";

/**
 * Get a random number between two numbers
 *
 * @param min Minimum number
 * @param max Maximum number
 * @returns Random number between min and max
 */
export function getRandomBetween(min: number, max: number): number {
    return Math.random() * (max - min) + min;
}

/**
 * Get a random item in a list
 */
export function getRandomItem<T>(...items: T[]): T {
    if (items.length === 0) {
        throw new Error("getRandomItem requires at least one item");
    }
    return items[clamp(Math.round(Math.random() * items.length - 0.5), 0, items.length - 1)];
}

/**
 * Returns a new array with the same elements in a uniformly random order (Fisher-Yates).
 * Does not mutate the input.
 */
export function shuffleArray<T>(arr: readonly T[]): T[] {
    const out = [...arr];
    for (let i = out.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [out[i], out[j]] = [out[j], out[i]];
    }
    return out;
}
